import React from 'react';

import { Box, Button, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import ChevronDown from 'components/SvgComponents/icons/ChevronDown';
import ChevronUp from 'components/SvgComponents/icons/ChevronUp';
import { CLASSIC_TYPO } from 'theme/typography';

export const SmallSelectButton = ({ isOpen = false, children, onOpen }) => (
  <Button
    onClick={onOpen}
    disableElevation
    disableRipple
    sx={{
      height: '30px',
      width: '100%',
      display: 'inline-flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingLeft: 3,
      paddingRight: 3,
      backgroundColor: 'background.primary',
      border: '2px solid',
      borderColor: 'background.primary',
      borderRadius: '24px',
      textTransform: 'none',
      fontFamily: CLASSIC_TYPO,
      color: 'text.primary',
      transition: 'all 0.3s ease-out',
      '&.Mui-disabled': {
        color: 'text.primary',
        opacity: '0.5',
      },
      '&:hover:not(disabled)': {
        color: 'text.dark',
      },
      '&:focus:not(disabled)': {
        color: 'text.dark',
      },
      '&:active:not(disabled)': {
        color: 'text.dark',
        backgroundColor: 'background.secondary',
        border: '2px solid',
        borderColor: 'background.secondary',
      },
    }}
  >
    <Typography variant="caption" sx={{ whiteSpace: 'nowrap', fontWeight: 'bold' }}>
      {children}
    </Typography>
    <Box sx={{ marginLeft: 2 }}>
      {isOpen ? <ChevronUp width={12} /> : <ChevronDown width={12} />}
    </Box>
  </Button>
);

SmallSelectButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  onOpen: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
};
